import ViewReportingPage from "components/viewReporting/ViewReporting.component"

const ViewReporting = () => {
  return (
    <ViewReportingPage />
  )
}

export default ViewReporting
